import React from 'react'
import TeamBG from '../../../../assets/bg/mobile/bg_team.png'

const TeamMobileComponent = () => {
  return (
    <div>
      <img src={TeamBG} />
    </div>
  )
}

export default TeamMobileComponent
